var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93874 18.9387L14.9387 8.93874C15.0781 8.7989 15.2437 8.68795 15.426 8.61224C15.6083 8.53653 15.8038 8.49756 16.0012 8.49756C16.1987 8.49756 16.3941 8.53653 16.5765 8.61224C16.7588 8.68795 16.9244 8.7989 17.0637 8.93874L27.0637 18.9387C27.3455 19.2205 27.5038 19.6027 27.5038 20.0012C27.5038 20.3998 27.3455 20.782 27.0637 21.0637C26.782 21.3455 26.3998 21.5038 26.0012 21.5038C25.6027 21.5038 25.2205 21.3455 24.9387 21.0637L16 12.125L7.06124 21.065C6.77945 21.3468 6.39726 21.5051 5.99874 21.5051C5.60023 21.5051 5.21804 21.3468 4.93624 21.065C4.65445 20.7832 4.49614 20.401 4.49614 20.0025C4.49614 19.604 4.65445 19.2218 4.93624 18.94L4.93874 18.9387Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandUp);
export default __webpack_public_path__ + "static/media/expandUp.357ebf580927463f551336e6439d2873.svg";
export { ForwardRef as ReactComponent };